import './bootstrap';
import 'bootstrap';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Alpine from 'alpinejs';
import Pusher from 'pusher-js';
import * as PusherPushNotifications from "@pusher/push-notifications-web";

window.Alpine = Alpine;
Alpine.start();

document.addEventListener('DOMContentLoaded', function () {
    // Configuración de Pusher Beams
    const beamsClient = new PusherPushNotifications.Client({
        instanceId: '15f771b8-a0ab-4aab-b05c-bdcd54149a13', 
    });

    // Suscribir al usuario a los intereses correspondientes
    const userRole = document.body.dataset.userRole; 
    const interests = userRole === 'admin' ? ['admin'] : userRole === 'ajustador' ? ['ajustador'] : [];

    beamsClient.start()
        .then(() => {
            interests.forEach(interest => beamsClient.addDeviceInterest(interest));
        })
        .then(() => console.log(`Beams inicializado y suscrito a los intereses: ${interests}`))
        .catch((error) => {
            if (error.name === 'NotAllowedError') {
                console.error('El usuario denegó el permiso para las notificaciones.');
                alert('Por favor, habilita las notificaciones en la configuración de tu navegador.');
            } else {
                console.error('Error al inicializar Pusher Beams:', error);
            }
        });

    // Registrar el Service Worker
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('/service-worker.js')
            .then((registration) => {
                console.log('Service Worker registrado con éxito:', registration);
            })
            .catch((error) => {
                console.error('Error al registrar el Service Worker:', error);
            });
    }

    // Configuración de Pusher para notificaciones en tiempo real
    const pusher = new Pusher('dcec14a7d1a7a0d29309', { 
        cluster: 'us2',
        encrypted: true,
    });

    // Suscribirse al canal correspondiente
    const channel = pusher.subscribe('admin-ajustadores');
    channel.bind('NuevaGarantiaCreada', function (data) {
        console.log('Notificación recibida:', data);

        const notificationLists = document.querySelectorAll('#notification-list');
        const notificationCounts = document.querySelectorAll('#notification-count');
        const noNotifications = document.querySelectorAll('#no-notifications');

        // Ocultar mensaje de "No hay notificaciones"
        noNotifications.forEach(noNotification => {
            noNotification.style.display = 'none';
        });

        // Incrementar contador de notificaciones
        notificationCounts.forEach(notificationCount => {
            let count = parseInt(notificationCount.textContent || '0');
            count++;
            notificationCount.textContent = count;
            notificationCount.classList.remove('hidden');
        });

        // Crear nueva notificación
        const li = document.createElement('li');
        li.className = 'px-4 py-3 hover:bg-gray-50';
        li.innerHTML = `
            <a href="/warranties/${data.warranty.id}" class="block">
                <strong>${data.message}</strong>
            </a>
        `;

        // Agregar la notificación al inicio de todas las listas
        notificationLists.forEach(notificationList => {
            notificationList.prepend(li.cloneNode(true));
        });
    });

    // Manejar evento de garantía actualizada
    channel.bind('GarantiaActualizada', function (data) {
        console.log('Notificación recibida (estatus actualizado):', data);

        const notificationLists = document.querySelectorAll('#notification-list');
        const notificationCounts = document.querySelectorAll('#notification-count');
        const noNotifications = document.querySelectorAll('#no-notifications');

        // Ocultar mensaje de "No hay notificaciones"
        noNotifications.forEach(noNotification => {
            noNotification.style.display = 'none';
        });

        // Incrementar contador de notificaciones
        notificationCounts.forEach(notificationCount => {
            let count = parseInt(notificationCount.textContent || '0');
            count++;
            notificationCount.textContent = count;
            notificationCount.classList.remove('hidden');
        });

        // Crear nueva notificación
        const li = document.createElement('li');
        li.className = 'px-4 py-3 hover:bg-gray-50';
        li.innerHTML = `
            <a href="/warranties/${data.warranty.id}" class="block">
                <strong>${data.message}</strong>
            </a>
        `;

        // Agregar la notificación al inicio de todas las listas
        notificationLists.forEach(notificationList => {
            notificationList.prepend(li.cloneNode(true));
        });
    });

    // Manejar clic en notificaciones
    document.addEventListener('click', function (event) {
        if (event.target.classList.contains('notification-link')) {
            event.preventDefault();

            const notificationItem = event.target.closest('li');
            const notificationId = notificationItem.getAttribute('data-id');

            // Marcar la notificación como leída
            notificationItem.classList.add('read');
            notificationItem.style.opacity = '0.7';

            // Redirigir al enlace de la notificación
            window.location.href = event.target.href;
        }
    });

    // Manejar eliminación de notificaciones
    document.addEventListener('click', function (event) {
        if (event.target.classList.contains('delete-notification')) {
            event.preventDefault();

            const notificationId = event.target.getAttribute('data-id');
            const notificationItem = event.target.closest('li');

            // Enviar solicitud al backend para eliminar la notificación
            fetch(`/notifications/${notificationId}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                },
            })
                .then(response => response.json())
                .then(data => {
                    console.log('Notificación eliminada:', data);
                    notificationItem.remove();
                })
                .catch(error => {
                    console.error('Error al eliminar la notificación:', error);
                });
        }
    });
    // Inicializar todos los tooltips de Bootstrap
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl);
    });

    // Inicializar todos los popovers de Bootstrap
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl);
    });

    // Inicializar modales
    var modalTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="modal"]'));
    var modalList = modalTriggerList.map(function (modalTriggerEl) {
        return new bootstrap.Modal(modalTriggerEl);
    });

    // Inicializar dropdowns
    var dropdownTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="dropdown"]'));
    var dropdownList = dropdownTriggerList.map(function (dropdownTriggerEl) {
        return new bootstrap.Dropdown(dropdownTriggerEl);
    });

    // Inicializar collapse
    var collapseTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="collapse"]'));
    var collapseList = collapseTriggerList.map(function (collapseTriggerEl) {
        return new bootstrap.Collapse(collapseTriggerEl);
    });

    // Función para mostrar mensajes de alerta
    window.showAlert = function (message, type = 'success') {
        const alertDiv = document.createElement('div');
        alertDiv.className = `alert alert-${type} alert-dismissible fade show`;
        alertDiv.role = 'alert';
        alertDiv.innerHTML = `
            ${message}
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        `;
        document.querySelector('.container').insertBefore(alertDiv, document.querySelector('.card'));
    };

    // Función para confirmar acciones
    window.confirmAction = function (message) {
        return confirm(message);
    };

    // Función para manejar errores de formulario
    window.handleFormErrors = function (errors) {
        Object.keys(errors).forEach(function (field) {
            const input = document.querySelector(`[name="${field}"]`);
            if (input) {
                input.classList.add('is-invalid');
                const feedback = document.createElement('div');
                feedback.className = 'invalid-feedback';
                feedback.textContent = errors[field][0];
                input.parentNode.appendChild(feedback);
            }
        });
    };
});